import { Target } from 'lucide-preact'
import { LeadGoalBar } from '@/components'

interface Props {
    leadGoal: number
    leadCount: number
    onNavigate: () => void
}

export function LeadsProgressButton({ leadGoal, leadCount, onNavigate }: Props) {
    const goal = Math.max(0, leadGoal)
    const sourced = Math.max(0, leadCount)
    const percentRaw = goal > 0 ? Math.round((sourced / goal) * 100) : null

    return (
        <button
            type="button"
            onClick={onNavigate}
            aria-label="Leads progress"
            className="group relative text-center px-5 py-4 rounded-xl border border-slate-200 dark:border-slate-600 bg-white/60 dark:bg-slate-900/30 backdrop-blur-sm hover:border-primary-400 dark:hover:border-primary-500 hover:shadow-md transition-all"
        >
            <div className="absolute inset-0 rounded-xl pointer-events-none opacity-0 group-hover:opacity-100 bg-gradient-to-br from-primary-50/70 to-primary-100/10 dark:from-primary-500/10 dark:to-primary-400/0 transition" />
            <div className="relative flex flex-col items-center">
                <div className="w-full flex items-center justify-center gap-2 text-xs uppercase tracking-wide text-slate-500 dark:text-slate-400 mb-1"><span>Leads Progress</span></div>
                <div className="text-2xl font-semibold text-slate-900 dark:text-white flex items-center gap-2">
                    <span className="relative inline-flex">
                        <Target className="w-6 h-6 text-primary-600 dark:text-primary-500 transform transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3" />
                        <span className="absolute -inset-1 rounded-full opacity-0 group-hover:opacity-70 bg-primary-500/10 blur-sm transition" />
                    </span>
                    <span>{sourced.toLocaleString()} {goal > 0 && <span className="text-slate-400 dark:text-slate-500">/ {goal.toLocaleString()}</span>}</span>
                </div>
                <div className="mt-2">
                    <LeadGoalBar
                        sourced={sourced}
                        goal={goal}
                        mode="simple"
                        trackClassName="w-44 h-2 rounded-full bg-slate-200 dark:bg-slate-700 overflow-hidden"
                        fillClassName="bg-primary-600"
                        animate
                        animationMs={500}
                    />
                </div>
                <div className="mt-1 text-[11px] font-medium text-slate-600 dark:text-slate-400 tracking-wide">{percentRaw !== null ? `${percentRaw}%` : '—'}</div>
            </div>
        </button>
    )
}
